export class PricingAndPackagingAPIError extends Error {
    message: string;
    statusCode: number;
    parsedError?: Record<string, any>;

    constructor({
        message,
        statusCode,
        parsedError,
    }: {
        message: string;
        statusCode: number;
        parsedError?: Record<string, any>;
    }) {
        super(message);
        this.message = message;
        this.statusCode = statusCode;
        this.parsedError = parsedError;
    }
}
